import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=admin
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    const token = localStorage.getItem("bnb_admin_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("bnb_admin_token");
      setUser(false);
    }
    setReady(true);
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bnb_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const sendOtp = async (phone) => {
    const { data } = await api.post("/auth/send-otp", { phone });
    return data;
  };

  const verifyOtp = async (phone, req_id, otp) => {
    const { data } = await api.post("/auth/verify-otp", { phone, req_id, otp });
    localStorage.setItem("bnb_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("bnb_admin_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, sendOtp, verifyOtp }}>
      {children}
    </AuthContext.Provider>
  );
}
